import React from 'react';
import { motion } from 'framer-motion';
const tomos = [{
  badge: 'TOMO 1',
  title: 'El Secreto de la Masa Perfecta en Casa',
  items: ['Hidratación al 70%', 'Amasado por pliegues', 'Fermentación en frío 24-48h', 'Horno casero a 400°C', 'Margherita Auténtica', 'La Marinara', 'La Diavola con nduja', 'Plan de 7 días', 'Hackear tu bandeja', 'Equivalencias de harinas'],
  value: '$197'
}, {
  badge: 'TOMO 2',
  title: 'Sabores de Autor y Alta Cocina',
  items: ['Masa de 5 cereales', 'Pizza In Teglia Romano', 'Toppings post-horno', 'Aceites de autor', 'Hot Honey 2026', 'Pistacho y Mortadella', 'Carbonara de Autor', 'Tartufata trufa negra', 'Plan gourmet 30 días', 'Pizza firma 72h'],
  value: '$197'
}];
export function ProductTomos() {
  return <div className="bg-[#111111] border-t border-b border-[#C0392B]/20 py-6 px-5" data-id="element-113">
      <div className="max-w-5xl mx-auto" data-id="element-114">
        <h2 className="font-serif text-xl sm:text-2xl md:text-3xl text-[#C0392B] text-center mb-1 uppercase tracking-wider" data-id="element-115">
          Lo que Vas a Recibir —{' '}
          <span className="text-[#F1C40F]" data-id="element-116">50 Recetas</span>
        </h2>
        <div className="w-16 h-0.5 bg-gradient-to-r from-[#C0392B] to-[#F1C40F] mx-auto rounded my-2" data-id="element-117" />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4" data-id="element-118">
          {tomos.map((tomo, index) => <motion.div key={index} className="bg-gradient-to-br from-[#1A1A1A] to-[#111111] border border-[#C0392B] rounded-xl p-4 sm:p-5 relative overflow-hidden" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.15
        }} data-id="element-119">
              <div className="absolute top-0 left-0 right-0 h-0.5 bg-gradient-to-r from-[#C0392B] via-[#F1C40F] to-[#27AE60]" data-id="element-120" />
              <div className="flex items-center gap-2 mb-2" data-id="element-121">
                <span className="bg-[#C0392B] text-white px-3 py-0.5 rounded-full text-[10px] font-bold tracking-wider" data-id="element-122">
                  {tomo.badge}
                </span>
                <span className="text-[#27AE60] text-[10px] font-bold" data-id="element-123">
                  Valor: {tomo.value}
                </span>
              </div>
              <h3 className="text-[#F1C40F] text-sm sm:text-base mb-2 font-serif uppercase tracking-wide" data-id="element-124">
                {tomo.title}
              </h3>
              <ul className="grid grid-cols-2 gap-x-3 gap-y-1" data-id="element-125">
                {tomo.items.map((item, i) => <li key={i} className="flex items-start gap-1.5 text-[#F5F5F5] text-[10px] leading-tight" data-id="element-126">
                    <span className="flex-shrink-0" data-id="element-127">🍕</span>
                    <span data-id="element-128">{item}</span>
                  </li>)}
              </ul>
            </motion.div>)}
        </div>

        {/* Categories inline */}
        <div className="flex flex-wrap justify-center gap-2 mt-4" data-id="element-129">
          {['🟥 Rojas', '⬜ Blancas', '🥗 Frescas', '🌎 Fusión', '👨‍🍳 Autor'].map((cat, i) => <span key={i} className="bg-[#1A1A1A] border border-[#C0392B]/30 rounded px-3 py-1 text-[10px] text-[#F5F5F5]" data-id="element-130">
              {cat} · 10
            </span>)}
        </div>
      </div>
    </div>;
}